<div class="summary" *ngIf="!noChangedMilkings">
	<h2>Se han modificado las alertas de {{ numberOfChangedMilkings }} ordeños</h2>

	<button class="app-btn tertiary excel-btn" (click)="onExportDetails()">Exportar cambios</button>
</div>

<div class="summary" *ngIf="noChangedMilkings">
	<h2>No se ha podido arreglar ninguna alerta</h2>

	<button class="app-btn tertiary excel-btn" (click)="onClose()">Ok</button>
</div>
